/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListServiceTicketsRequest as AgentApiContractListServiceTicketsRequest } from '../../models/AgentApi/Contract/list-service-tickets-request';
import { ListServiceTicketsResponse as AgentApiContractListServiceTicketsResponse } from '../../models/AgentApi/Contract/list-service-tickets-response';

export interface ApiAgentListServiceTicketsPost$Plain$Params {

/**
 * ui language code.
 */
  lang?: string;
      body?: AgentApiContractListServiceTicketsRequest
}

export function apiAgentListServiceTicketsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiAgentListServiceTicketsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AgentApiContractListServiceTicketsResponse>>> {
  const rb = new RequestBuilder(rootUrl, apiAgentListServiceTicketsPost$Plain.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AgentApiContractListServiceTicketsResponse>>;
    })
  );
}

apiAgentListServiceTicketsPost$Plain.PATH = '/api/Agent/ListServiceTickets';
